module.exports = __webpack_public_path__ + "img/children-1.143a20cf.jpg";